import { render } from "./BlogThreeColumn.vue?vue&type=template&id=2796531e&scoped=true"
import script from "./BlogThreeColumn.vue?vue&type=script&lang=js"
export * from "./BlogThreeColumn.vue?vue&type=script&lang=js"

import "./BlogThreeColumn.vue?vue&type=style&index=0&id=2796531e&scoped=true&lang=css"

import exportComponent from "E:\\量化\\my-websit-ai - 副本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2796531e"]])

export default __exports__